(function () {
    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports(
            require('./strings/strings.js'),
            require('lodash'),
            require('underscore.string'),
            require('sprintf-js').sprintf
        );
    } else {
        RivalIQ.str = exports(
            RivalIQ.strings,
            window._,
            window.s,
            window.sprintf
        );
    }

    function exports(strings, _, s, sprintf) {
        return function str(id) {
            const string = strings[id];
            if (_.isUndefined(string)) {
                throw new Error(`Template string undefined: ${id}`);
            }
            return sprintf.apply(null, [string].concat(_.tail(arguments)));
        };
    }
})();
